import httpClient from '../config/httpClient';
import { subscribeToIntegrationStatus } from './integrationImport';

export const connectKeka = async (
  companyId,
  userId,
  kekaCompanySlug,
  clientId,
  clientSecret,
  apiKey
) => {
  const { data } = await httpClient.post('/kekaConnect', {
    companyId,
    userId,
    kekaCompanySlug,
    clientId,
    clientSecret,
    apiKey,
  });
  return data;
};

export const disconnectKeka = async (companyId, userId) => {
  const { data } = await httpClient.post('/kekaDisconnect', {
    companyId,
    userId,
  });
  return data;
};

export const getKekaEmployees = async (companyId) => {
  const { data } = await httpClient.post('/kekaGetEmployees', { companyId });
  return data;
};

export const autoMapKekaEmployees = async (companyId, teamId) => {
  const { data } = await httpClient.post('/kekaAutoMapEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const saveKekaMappings = async (companyId, mappings) => {
  const { data } = await httpClient.post('/kekaSaveMappings', {
    companyId,
    mappings,
  });
  return data;
};

export const syncKekaTimeRange = async (
  companyId,
  teamId,
  startDate,
  endDate
) => {
  const { data } = await httpClient.post('/kekaSyncTimeRange', {
    companyId,
    teamId,
    startDate,
    endDate,
  });
  return data;
};

const DISCONNECTED_KEKA_STATUS = {
  connected: false,
  kekaCompanySlug: null,
  connectedAt: null,
  connectedBy: null,
  employeeMappings: {},
  employeeMappingsUpdatedAt: null,
  lastSyncAt: null,
  lastSyncStats: null,
};

export const subscribeToKekaStatus = (companyId, onUpdate) => {
  return subscribeToIntegrationStatus(
    companyId,
    'keka',
    ({ exists, data: d }) => {
      if (!exists || !d.connected) {
        onUpdate(DISCONNECTED_KEKA_STATUS);
        return;
      }
      onUpdate({
        connected: true,
        kekaCompanySlug: d.kekaCompanySlug || null,
        connectedAt: d.connectedAt ? new Date(d.connectedAt) : null,
        connectedBy: d.connectedBy || null,
        employeeMappings: d.employeeMappings || {},
        employeeMappingsUpdatedAt: d.employeeMappingsUpdatedAt
          ? new Date(d.employeeMappingsUpdatedAt)
          : null,
        lastSyncAt: d.lastSyncAt ? new Date(d.lastSyncAt) : null,
        lastSyncStats: d.lastSyncStats || null,
      });
    }
  );
};
